









import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class InputItem extends Vue {
    @Prop({default: ''}) readonly value!: string;
    @Prop({required: true}) fieldName!: string;
    @Prop(String) placeholder?: string;

    onValueChange(value: string) {
        this.$emit('update:value', value);
    }
}
